module.exports = __webpack_public_path__ + "img/instagram_2111463.5c570427.png";